// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3mT0y","sm":"Loading_sm__PnaIG","md":"Loading_md__3OOOt","lg":"Loading_lg__1Hrdy"};